import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import "../FormStyle.scss";
import { useField } from "formik";

interface EmailWithValidationProps {
  id: string;
  initialValue?: string | null;
  label?: string;
  required?: boolean;
  validationFunction?: (input: string) => boolean;
  onChangeText?: (value: string) => void;
  useDefaultValidation?: boolean;
  validationResult?: (input: string, result: boolean) => void;
  name: string;
}

export const EmailWithValidation = forwardRef(
  (props: Readonly<EmailWithValidationProps>, ref) => {
    const {
      id,
      initialValue,
      label,
      required,
      validationFunction,
      onChangeText,
      useDefaultValidation,
      validationResult,
      name,
    } = props;

    const [field, meta, helpers] = useField(name);
    const { setValue, setTouched } = helpers;

    //const [value, setValue] = useState(initialValue ?? "");
    const [isValid, setIsValid] = useState<boolean | undefined>(undefined);

    function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
      const changedValue = event.target.value ?? "";
      setValue(changedValue);
      if (onChangeText) onChangeText(changedValue);
    }

    function handleBlur(event: React.FocusEvent<HTMLInputElement>): boolean {
      let result = required ? field.value !== "" : true;

      if (useDefaultValidation) {
        const regex = /^\S+@\S+\.\S+$/;
        result = regex.test(field.value);
      }
      
      if (validationFunction) result = validationFunction(field.value);
      if (validationResult) validationResult(field.value, result);
      
      setIsValid(result);
      setTouched(true);

      return result;
    }

    useImperativeHandle(ref, () => ({
      validate(): boolean {
        console.debug(`Validating: ${label}.`);
        return handleBlur({} as React.FocusEvent<HTMLInputElement>);
      },
    }));

    return (
      <Form.Group controlId={id}>
        <FloatingLabel label={label} className="mb-3">
          <Form.Control
            {...field}
            type="email"
            placeholder="email@domain.com"
            required={required}
            value={field.value}
            onChange={handleInputChange}
            onBlur={handleBlur}
            isValid={isValid}
            isInvalid={isValid !== undefined && !isValid}
          ></Form.Control>
          <Form.Control.Feedback type="invalid">
            Invalid e-mail.
          </Form.Control.Feedback>
        </FloatingLabel>
      </Form.Group>
    );
  }
);

EmailWithValidation.defaultProps = {
  label: "Email",
  required: true,
  useDefaultValidation: true,
};

export default EmailWithValidation;



